import { useState } from 'react';

type PreviewOptions<T> = {
    onChange?: (isPreviewing: boolean, preview?: T) => void;
};

const usePreview = <T>({ onChange }: PreviewOptions<T>) => {
    const [preview, setPreview] = useState<T>();

    const startPreview = (bm: T) => {
        setPreview(bm);
        onChange?.(true, bm);
    };
    const cancelPreview = () => {
        setPreview(undefined);
        onChange?.(false);
    };

    return {
        isPreviewing: !!preview,
        current: preview,
        start: startPreview,
        cancel: cancelPreview,
    };
};

export default usePreview;
